export default function PreparationItemReportDirective() {
  return {
    template: require('./preparation-item-report.html'),
    scope: {
      preparationItemId: '=',
      canEdit: '=',
      canDelete: '=',
      preparationItemReport: '=',
    },
    controller: 'PreparationItemReportController',
    controllerAs: 'preparationItemReportVM',
    bindToController: true,
    replace: true
  };
}
